module.exports = __webpack_public_path__ + "img/config_none.39c8feeb.jpg";